/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPTRANSFERMETHOD } from './IAPTRANSFERMETHOD';
import {
    IAPTRANSFERMETHODFromJSON,
    IAPTRANSFERMETHODFromJSONTyped,
    IAPTRANSFERMETHODToJSON,
} from './IAPTRANSFERMETHOD';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface InvestmentDetailsTFSATransferViewModel
 */
export interface InvestmentDetailsTFSATransferViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    paymentCategoryId?: number;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    hasTFSATransfer: IAPYESORNO;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    hasCurrentTaxYearContribution?: IAPYESORNO;
    /**
     * 
     * @type {IAPTRANSFERMETHOD}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    transferMethodId?: IAPTRANSFERMETHOD;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    totalLifeTimeContributionAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    currentTaxYearContributionAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsTFSATransferViewModel
     */
    amount?: number;
}

/**
 * Check if a given object implements the InvestmentDetailsTFSATransferViewModel interface.
 */
export function instanceOfInvestmentDetailsTFSATransferViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasTFSATransfer" in value;

    return isInstance;
}

export function InvestmentDetailsTFSATransferViewModelFromJSON(json: any): InvestmentDetailsTFSATransferViewModel {
    return InvestmentDetailsTFSATransferViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsTFSATransferViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsTFSATransferViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'paymentCategoryId': !exists(json, 'PaymentCategoryId') ? undefined : json['PaymentCategoryId'],
        'hasTFSATransfer': IAPYESORNOFromJSON(json['HasTFSATransfer']),
        'hasCurrentTaxYearContribution': !exists(json, 'HasCurrentTaxYearContribution') ? undefined : IAPYESORNOFromJSON(json['HasCurrentTaxYearContribution']),
        'transferMethodId': !exists(json, 'TransferMethodId') ? undefined : IAPTRANSFERMETHODFromJSON(json['TransferMethodId']),
        'totalLifeTimeContributionAmount': !exists(json, 'TotalLifeTimeContributionAmount') ? undefined : json['TotalLifeTimeContributionAmount'],
        'currentTaxYearContributionAmount': !exists(json, 'CurrentTaxYearContributionAmount') ? undefined : json['CurrentTaxYearContributionAmount'],
        'amount': !exists(json, 'Amount') ? undefined : json['Amount'],
    };
}

export function InvestmentDetailsTFSATransferViewModelToJSON(value?: InvestmentDetailsTFSATransferViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'PaymentCategoryId': value.paymentCategoryId,
        'HasTFSATransfer': IAPYESORNOToJSON(value.hasTFSATransfer),
        'HasCurrentTaxYearContribution': IAPYESORNOToJSON(value.hasCurrentTaxYearContribution),
        'TransferMethodId': IAPTRANSFERMETHODToJSON(value.transferMethodId),
        'TotalLifeTimeContributionAmount': value.totalLifeTimeContributionAmount,
        'CurrentTaxYearContributionAmount': value.currentTaxYearContributionAmount,
        'Amount': value.amount,
    };
}

